import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import actionType from 'utils/mw/actionType.util';

const ATAG = 'beGetBillingDetails';
const AT = actionType(ATAG);

const beGetBillingDetails = withOptions(({ salonId }) =>
  endpoint(H.get, 'stripe/:salonId/get_customer/', {
    AT,
    name: ATAG,
    params: { salonId },
  }),
);

beGetBillingDetails.AT = AT;
beGetBillingDetails.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beGetBillingDetails;
